module.exports = __webpack_public_path__ + "static/img/logo2.cdcc4c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/logo2.png
// module id = PP70
// module chunks = 30